/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

import React from 'react';
import propTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';


/**
 * A Component to show progress
 *
 * @author Hari Gangadharan
 */

const Progress = props => <CircularProgress {...props} />;

Progress.propTypes = {
  style: propTypes.shape({
    color: propTypes.string,
    zIndex: propTypes.number,
    margin: propTypes.string
  }),
  size: propTypes.number,
  thickness: propTypes.number
};

Progress.defaultProps = {
  style: {
    zIndex: 1000,
    color: '#005a70',
    margin: '150px 50%'
  },
  size: 40,
  thickness: 3.6
};

export default Progress;



// WEBPACK FOOTER //
// ./src/js/components/Progress/Progress.jsx